import loadable from '@wix/yoshi-flow-editor/loadable';
import type {DropdownProps} from '@wix/wix-ui-tpa/cssVars';

export const LazyDropdown = loadable<DropdownProps>(
  () => import(/* webpackChunkName: "LazyWUTComponents" */ './WUTComponents'),
  {
    resolveComponent: (component) => component.Dropdown,
  }
);
